/**
 * Docusign's mark on its own, cropped to fill its box.
 *
 * `icons/esign/Docusign` is a 20x20 *tile*: the same glyph floating inside a
 * grey bordered card, which is right where it is used (offer previews) and
 * wrong on an integration card. There the tile's border read as a stray box and
 * its padding left the mark noticeably smaller than PandaDoc, Adobe Sign and
 * SpotDraft beside it — the glyph occupies only 10.75 of that file's 20 units.
 *
 * Same paths, no tile, and a viewBox trimmed to the glyph's own bounds so it
 * fills the shared 24px slot like every other mark.
 */
const SvgDocusignLogo = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="4.62 4.62 10.76 10.76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.3675 12.3647V15.1125C12.3675 15.2568 12.2509 15.3734 12.1066 15.3734H4.88474C4.74041 15.3734 4.62384 15.2568 4.62384 15.1125V7.89617C4.62384 7.75185 4.74041 7.63527 4.88474 7.63527H7.62694V12.1038C7.62694 12.2482 7.74351 12.3647 7.88784 12.3647H12.3675Z"
      fill="#4C00FF"
    />
    <path
      d="M15.3762 8.49013C15.3762 10.7994 14.0273 12.3592 12.3675 12.3647V9.45601C12.3675 9.37274 12.3342 9.28948 12.2731 9.23397L10.7633 7.72409C10.7022 7.66303 10.6245 7.62972 10.5412 7.62972H7.63249V4.88752C7.63249 4.7432 7.74906 4.62662 7.89339 4.62662H11.9623C13.894 4.62107 15.3762 6.17536 15.3762 8.49013Z"
      fill="#FF5252"
    />
    <path
      d="M12.2731 9.22842C12.3342 9.28948 12.3675 9.36719 12.3675 9.45046V12.3592H7.89339C7.74906 12.3592 7.63249 12.2426 7.63249 12.0983V7.62972H10.5412C10.6245 7.62972 10.7078 7.66303 10.7633 7.72409L12.2731 9.22842Z"
      fill="black"
    />
  </svg>
);
export default SvgDocusignLogo;
